import React from 'react';
import cx from 'classnames';
import Link from 'next/link';
import { FaFacebook, FaGithub, FaInstagram, FaTwitter } from 'react-icons/fa';
import Image from 'next/image';
import useWindowSize from '@/utils/useWindowSize';
import { NavLink } from '@/data/navLinks';
import NewsletterForm from '../NewsletterForm';

export default function Footer() {
  const { mobile } = useWindowSize();
  return (
    <footer className="bg-dark-background dark:bg-darker-background">
      <NewsletterForm />
      <div className="max-w-6xl mx-auto px-4 py-12">
        <div className="grid items-center grid-cols-1 md:grid-cols-3 gap-8">
          <div className="col-span-1 md:col-span-2">
            <Link href={NavLink.HOME}>
              <div className={cx({ 'flex md:mb-6': true, 'justify-center': mobile })}>
                <Image
                  src="/images/logoWhite.png"
                  width={mobile ? 160 : 200}
                  height={mobile ? 125 : 142}
                  alt="Pcollins"
                />
              </div>
            </Link>
          </div>
          <div className="text-center md:text-right">
            <div className="flex flex-col items-center md:items-end space-y-4 mb-8">
              <Link
                href="mailto:phil@pcollins.tech" 
                className="flex items-center space-x-3 text-xl text-white hover:text-pink-500 transition-colors"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 512 512">
                  <path d="M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z" />
                </svg>
                <span>phil@pcollins.tech</span>
              </Link>
              <Link 
                href="tel:07944305605" 
                className="flex items-center space-x-3 text-xl text-white hover:text-pink-500 transition-colors"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 512 512">
                  <path d="M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z" />
                </svg>
                <span>07944305605</span>
              </Link>
            </div>
            <div className="flex justify-center md:justify-end space-x-6">
              <Link
                href="https://www.facebook.com/pcollins.tech/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-3xl text-gray-300 hover:text-pink-500 transition-colors"
              >
                <FaFacebook />
              </Link>
              <Link
                href="https://www.instagram.com/pcollins.tech/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-3xl text-gray-300 hover:text-pink-500 transition-colors"
              >
                <FaInstagram />
              </Link>
              <Link 
                href="https://www.twitter.com/pcollinsTech/" 
                target="_blank"
                rel="noopener noreferrer"
                className="text-3xl text-gray-300 hover:text-pink-500 transition-colors"
              >
                <FaTwitter />
              </Link>
              <Link 
                href="https://www.github.com/pcollinsEG/" 
                target="_blank"
                rel="noopener noreferrer"
                className="text-3xl text-gray-300 hover:text-pink-500 transition-colors"
              >
                <FaGithub />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
